import { useEffect } from "react";
import { Instagram } from "lucide-react";
import { useSite } from "@/lib/useSite";

function loadInstagramEmbed() {
  if (window.instgrm) {
    window.instgrm.Embeds.process();
    return;
  }
  if (document.getElementById("instagram-embed-script")) return;
  const script = document.createElement("script");
  script.id = "instagram-embed-script";
  script.src = "https://www.instagram.com/embed.js";
  script.async = true;
  document.body.appendChild(script);
}

export default function InstagramWall() {
  const { data } = useSite();
  const items = data?.instagram_videos || [];

  useEffect(() => {
    if (!items.length) return;
    loadInstagramEmbed();
    const t = setTimeout(() => {
      if (window.instgrm) window.instgrm.Embeds.process();
    }, 300);
    return () => clearTimeout(t);
  }, [items]);

  if (!items.length) return null;

  return (
    <div data-testid="instagram-wall">
      <p className="mb-8 font-mono text-[11px] uppercase tracking-[0.25em] text-subtle">On Instagram</p>
      <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((v, i) => (
          <div key={v.id} data-testid={`instagram-card-${i}`} className="overflow-hidden rounded-[1.5rem] border border-ink/10 bg-white">
            <blockquote
              className="instagram-media"
              data-instgrm-permalink={v.url}
              data-instgrm-version="14"
              style={{ margin: 0, width: "100%" }}
            />
            {v.views && (
              <div className="flex items-center gap-2 border-t border-ink/10 px-4 py-3">
                <Instagram size={14} className="text-srs" />
                <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-subtle">{v.views} views</span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
